import store from '@/store'
import { Toast } from 'vant'

import router from '@/router'

import {
  WX_ORIGIN_ID
} from './constant'

export const ossUrl = process.env.VUE_APP_DOMAIN

const category = navigator.userAgent
export const isMiniprogram = window.__wxjs_environment === 'miniprogram' // 微信小程序
const isAndroid = category.indexOf('Android') > -1 || category.indexOf('Adr') > -1 // android终端
const isiOS = !!category.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // i
export function unAuth () {
  store.commit('auth/changeToken', '')
  window.token && window.token.unAuth()
}

export function auth () {
  return new Promise(resolve => {
    let token = ''
    if (isAndroid) {
      token = window.token && window.token.getToken()
    }
    if (isiOS || isiOS.length) {
      token = window.emitToken && window.emitToken()
    }
    store.commit('auth/changeToken', token)
    resolve()
  })
}

/**
 * 跳转 app
 * @param {*} name
 * withdrawal 提现
 * coupons 优惠券
 * register 注册
 * invite 邀请司机|乘客
 * call 打电话
 * city 城市
 * vehicle 车型
 * back 返回上一级
 */
export function handleApp (name, params = {}, callback) {
  if (isMiniprogram) {
    callback && callback(params, true)
  } else if (isAndroid && window.android) {
    window.android[name](JSON.stringify(params))
  } else if ((isiOS || isiOS.length) && window.webkit) {
    window.webkit.messageHandlers[name].postMessage(params)
  } else {
    callback && callback(params, false)
  }
}

/**
 * 分享 app
 * @param {*} key
 * driver 司机
 * user 乘客
 */
export function handleInvite (key, callback) {
  let params = {
    userName: WX_ORIGIN_ID,
    webpageUrl: `${ossUrl}/#/promote/${key}/register?userId=${store.state.auth.userId}`
  }
  if (key === 'user') {
    params = {
      ...params,
      path: `/sfc/pages/activity/user/invitee/passenger/index?inviterId=${store.state.auth.userId}&activityId=212570000006`,
      title: '好友送你50元优惠券，快来领取乘顺风车~',
      bg: 'https://dyyy-static.oss-cn-shenzhen.aliyuncs.com/sfc-assets/images/activity/11.png'
    }
  } else {
    params = {
      ...params,
      path: `/sfc/pages/activity/user/invitee/driver/index?inviterId=${store.state.auth.userId}&activityId=212570000009`,
      title: '好友邀请你注册车主，顺路接单赚路费~',
      bg: 'https://dyyy-static.oss-cn-shenzhen.aliyuncs.com/sfc-assets/images/activity/10.png'
    }
  }
  handleApp('invite', params, callback)
}

/**
 * 保存图片
 * @param {*} url
 */
export function handleImage (url) {
  if (isMiniprogram) {
    Toast('请长按二维码保存')
    return true
  }
  if (((isiOS || isiOS.length) && window.webkit) || (isAndroid && window.android)) {
    handleApp('saveImg', { url })
    return true
  }
  return false
}

/**
 * 下载app
 * @param {*} type
 * driver 司机
 * user 乘客
 */
export function handleDownload () {
  if (isMiniprogram) {
    window.wx.miniProgram.navigateTo('/pages/index/index')
  } else if (isAndroid) {
    router.push('/download')
  } else if (isiOS) {
    window.location.href = 'https://apps.apple.com/cn/app/id1568981884'
  }
}
